/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { createEmptyStateResource, StateResource } from '@common/tech-shared';
import { Component, Input } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'ozgcloud-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  imports: [MatProgressSpinner],
})
export class SpinnerComponent {
  @Input() diameter: number = 70;
  @Input() padding: number = 16;
  @Input() text: string;

  @Input() set stateResource(value: StateResource<unknown>) {
    this._stateResource = value;
    this._updateVisibility();
  }

  @Input() set show(value: boolean) {
    this._show = value;
    this._updateVisibility();
  }

  private _show: boolean = false;
  private _stateResource: StateResource<unknown> = createEmptyStateResource<unknown>();

  public showSpinner: boolean = false;

  _updateVisibility(): void {
    this.showSpinner = this._show || this._stateResource.loading || this._stateResource.reload;
  }
}
